import ErrorModal from './ErrorModal';

export interface PaymentFailedModalProps {
  message: string;
}

export default function PaymentFailedModal({ message }: PaymentFailedModalProps) {
  return <ErrorModal title="Betalning misslyckades!" message={message} />;
}
